export default "__VITE_ASSET__FoAvGSOY__"